import { Box } from '@stenajs-webui/core';
import { Spinner } from '@stenajs-webui/elements';

export const ModalLoader = () => (
  <Box alignItems={'center'} justifyContent={'center'} indent={2} spacing={2}>
    <Spinner size={'medium'} />
  </Box>
);
